import {
  FileTextOutlined,
  ShopOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

const CorporateSidebar = ({ corporateId }): ReactElement => {
  const pathname = window.location?.pathname;

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu
            defaultSelectedKeys={["0"]}
            // defaultOpenKeys={['sub1']}
            mode="inline"
          >
            <Menu.Item
              key="details"
              className={pathname.includes(`/details`) ? "active" : ""}
              icon={<ShopOutlined />}
            >
              <Link to={`/corporates/${corporateId}/details`}>
                Corporate Information
              </Link>
            </Menu.Item>

            <Menu.Item
              key="employee-group"
              icon={<UsergroupAddOutlined />}
              className={pathname.includes("/employee-group") ? "active" : ""}
            >
              <Link to={`/corporates/${corporateId}/employee-group`}>
                Employee Group
              </Link>
            </Menu.Item>

            <Menu.Item
              key="employees"
              icon={<UserOutlined />}
              className={pathname.includes("/employees") ? "active" : ""}
            >
              <Link to={`/corporates/${corporateId}/employees`}>
                Employee Management
              </Link>
            </Menu.Item>

            <Menu.Item
              key="topup"
              icon={<FileTextOutlined />}
              className={pathname.includes("/topup") ? "active" : ""}
            >
              <Link to={`/corporates/${corporateId}/topup`}>Topup History</Link>
            </Menu.Item>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default CorporateSidebar;
